module.exports = __webpack_public_path__ + "img/setting.3cb90a08.svg";